import * as React from 'react';



export default class Emptydiary extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg width="203" height="191" viewBox="0 0 203 191" version="1.1" xmlns="http://www.w3.org/2000/svg" className={this.props.className}>
            <defs>
            <path id="diary__a" d="M0.331 80.458L46.232 80.458 22.691 0.396z"/>
            <path id="diary__d" d="M20.756.233c-1.067 0-1.973.782-2.123 1.836L.021 118.639c-.013.09-.021.178-.021.266v.071c.019 1.142.956 2.096 2.144 2.096h156.31c1.07 0 1.974-.783 2.124-1.836L179.19 2.666c.183-1.285-.82-2.433-2.123-2.433H20.757z"/>
            <path id="diary__g" d="M2.672 0.448L0.047 17.944 17.931 17.944 20.556 0.448z"/>
            <path id="diary__j" d="M3.076 0.448L0.544 17.944 17.789 17.944 20.321 0.448z"/>
            <path id="diary__l" d="M2.931 0.448L0.306 17.944 18.191 17.944 20.815 0.448z"/>
            <path id="diary__n" d="M2.674 0.448L0.048 17.944 17.932 17.944 20.557 0.448z"/>
            <path id="diary__p" d="M3.056 0.013L0.526 17.508 17.771 17.508 20.302 0.013z"/>
            <path id="diary__r" d="M2.912 0.013L0.287 17.508 18.171 17.508 20.796 0.013z"/>
            <path id="diary__t" d="M2.654 0.013L0.029 17.508 17.913 17.508 20.538 0.013z"/>
            <path id="diary__w" d="M3.058 0.013L0.527 17.508 17.773 17.508 20.303 0.013z"/>
            <path id="diary__y" d="M2.892 0.102L0.268 17.598 18.152 17.598 20.777 0.102z"/>
            <path id="diary__A" d="M2.635 0.102L0.009 17.598 17.894 17.598 20.518 0.102z"/>
            <path id="diary__C" d="M3.04 0.102L0.508 17.598 17.753 17.598 20.285 0.102z"/>
            <path id="diary__E" d="M2.894 0.102L0.269 17.598 18.153 17.598 20.778 0.102z"/>
            <linearGradient id="diary__b" x1="50%" x2="50%" y1="0%" y2="150.52%">
                <stop offset="0%" stopColor="#ECEFF1"/>
                <stop offset="100%" stopColor="#FFF"/>
            </linearGradient>
            <linearGradient id="diary__e" x1="50%" x2="50%" y1="0%" y2="150.52%">
                <stop offset="0%" stopColor="#ECEFF1"/>
                <stop offset="100%" stopColor="#FFF"/>
            </linearGradient>
            <linearGradient id="diary__h" x1="50%" x2="50%" y1="0%" y2="97.579%">
                <stop offset="0%" stopColor="#FFD4D4" stopOpacity=".717"/>
                <stop offset="100%" stopColor="#F6F7F8"/>
            </linearGradient>
            <linearGradient id="diary__u" x1="50%" x2="50%" y1="0%" y2="97.579%">
                <stop offset="0%" stopColor="#FFD4D4" stopOpacity=".717"/>
                <stop offset="100%" stopColor="#F6F7F8"/>
            </linearGradient>
            <linearGradient id="diary__G" x1="50%" x2="50%" y1="100%" y2="0%">
                <stop offset="0%" stopColor="#E2E5E7"/>
                <stop offset="100%" stopColor="#FFF"/>
            </linearGradient>
            <linearGradient id="diary__H" x1="50%" x2="50%" y1="0%" y2="74.191%">
                <stop offset="0%" stopColor="#EAEFF2"/>
                <stop offset="100%" stopColor="#FFF"/>
            </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
            <g transform="translate(0 10.013)">
                <g transform="translate(156.574 1.82)">
                    <mask id="diary__c" fill="#fff">
                        <use xlinkHref="#diary__a"/>
                    </mask>
                    <path fill="url(#diary__b)" d="M0.331 80.458L46.232 80.458 22.691 0.396z" mask="url(#diary__c)"/>
                </g>
                <mask id="diary__f" fill="#fff">
                    <use xlinkHref="#diary__d"/>
                </mask>
                <path fill="url(#diary__e)" d="M20.756.233c-1.067 0-1.973.782-2.123 1.836L.021 118.639c-.013.09-.021.178-.021.266v.071c.019 1.142.956 2.096 2.144 2.096h156.31c1.07 0 1.974-.783 2.124-1.836L179.19 2.666c.183-1.285-.82-2.433-2.123-2.433H20.757z" mask="url(#diary__f)"/>
                <g transform="translate(27.31 81.928)">
                    <mask id="diary__i" fill="#fff">
                        <use xlinkHref="#diary__g"/>
                    </mask>
                    <path fill="url(#diary__h)" d="M2.672 0.448L0.047 17.944 17.931 17.944 20.556 0.448z" mask="url(#diary__i)"/>
                </g>
                <g transform="translate(60.991 81.928)">
                    <mask id="diary__k" fill="#fff">
                        <use xlinkHref="#diary__j"/>
                    </mask>
                    <path fill="#E9EDEF" d="M3.076 0.448L0.544 17.944 17.789 17.944 20.321 0.448z" mask="url(#diary__k)"/>
                </g>
                <g transform="translate(94.673 81.928)">
                    <mask id="diary__m" fill="#fff">
                        <use xlinkHref="#diary__l"/>
                    </mask>
                    <path fill="#E9EDEF" d="M2.931 0.448L0.306 17.944 18.191 17.944 20.815 0.448z" mask="url(#diary__m)"/>
                </g>
                <g transform="translate(129.265 81.928)">
                    <mask id="diary__o" fill="#fff">
                        <use xlinkHref="#diary__n"/>
                    </mask>
                    <path fill="#E9EDEF" d="M2.674 0.448L0.048 17.944 17.932 17.944 20.557 0.448z" mask="url(#diary__o)"/>
                </g>
                <g transform="translate(30.95 49.157)">
                    <mask id="diary__q" fill="#fff">
                        <use xlinkHref="#diary__p"/>
                    </mask>
                    <path fill="#E9EDEF" d="M3.056 0.013L0.526 17.508 17.771 17.508 20.302 0.013z" mask="url(#diary__q)"/>
                </g>
                <g transform="translate(65.543 49.157)">
                    <mask id="diary__s" fill="#fff">
                        <use xlinkHref="#diary__r"/>
                    </mask>
                    <path fill="#E9EDEF" d="M2.912 0.013L0.287 17.508 18.171 17.508 20.796 0.013z" mask="url(#diary__s)"/>
                </g>
                <g transform="translate(99.224 49.157)">
                    <mask id="diary__v" fill="#fff">
                        <use xlinkHref="#diary__t"/>
                    </mask>
                    <path fill="url(#diary__u)" d="M2.654 0.013L0.029 17.508 17.913 17.508 20.538 0.013z" mask="url(#diary__v)"/>
                </g>
                <g transform="translate(132.906 49.157)">
                    <mask id="diary__x" fill="#fff">
                        <use xlinkHref="#diary__w"/>
                    </mask>
                    <path fill="#E9EDEF" d="M3.058 0.013L0.527 17.508 17.773 17.508 20.303 0.013z" mask="url(#diary__x)"/>
                </g>
                <g transform="translate(35.502 16.386)">
                    <mask id="diary__z" fill="#fff">
                        <use xlinkHref="#diary__y"/>
                    </mask>
                    <path fill="#E9EDEF" d="M2.892 0.102L0.268 17.598 18.152 17.598 20.777 0.102z" mask="url(#diary__z)"/>
                </g>
                <g transform="translate(70.094 16.386)">
                    <mask id="diary__B" fill="#fff">
                        <use xlinkHref="#diary__A"/>
                    </mask>
                    <path fill="#E9EDEF" d="M2.635 0.102L0.009 17.598 17.894 17.598 20.518 0.102z" mask="url(#diary__B)"/>
                </g>
                <g transform="translate(103.776 16.386)">
                    <mask id="diary__D" fill="#fff">
                        <use xlinkHref="#diary__C"/>
                    </mask>
                    <path fill="#E9EDEF" d="M3.04 0.102L0.508 17.598 17.753 17.598 20.285 0.102z" mask="url(#diary__D)"/>
                </g>
                <g transform="translate(137.457 16.386)">
                    <mask id="diary__F" fill="#fff">
                        <use xlinkHref="#diary__E"/>
                    </mask>
                    <path fill="#E9EDEF" d="M2.894 0.102L0.269 17.598 18.153 17.598 20.778 0.102z" mask="url(#diary__F)"/>
                </g>
            </g>
            <path fill="url(#diary__G)" d="M71.55 0c1.021 0 1.848.827 1.848 1.848 0 .102-.008.205-.025.306l-2.188 12.988c-.21 1.243-1.286 2.154-2.547 2.154-1.02 0-1.848-.827-1.848-1.848 0-.102.009-.205.026-.306l2.187-12.988C69.213.911 70.29 0 71.551 0zM125.26 0c1.02 0 1.847.827 1.847 1.848 0 .102-.009.205-.026.306l-2.187 12.988c-.21 1.243-1.287 2.154-2.548 2.154-1.02 0-1.847-.827-1.847-1.848 0-.102.008-.205.025-.306l2.188-12.988C122.922.911 123.998 0 125.259 0z"/>
            <path fill="url(#diary__H)" d="M197 191c0-27.062-43.205-49-96.5-49S4 163.938 4 191"/>
        </g>
        </svg>
    )
  }
}
